module.exports = "<app-subsidiary-company-list></app-subsidiary-company-list>\r\n"